/**
 * Entry List Component - Displays grid of entry cards
 */

import React from 'react';
import { useTranslation } from 'react-i18next';
import { Grid, Box, Typography, Paper } from '@mui/material';
import { VerifiedEntry } from '@/types/api';
import EntryCard from './EntryCard';

interface EntryListProps {
  entries: VerifiedEntry[];
  onEdit?: (entry: VerifiedEntry) => void;
  onDelete?: (entry: VerifiedEntry) => void;
}

const EntryList: React.FC<EntryListProps> = ({
  entries,
  onEdit,
  onDelete,
}) => {
  const { t } = useTranslation('components');

  if (entries.length === 0) {
    return (
      <Paper sx={{ p: 4, textAlign: 'center' }}>
        <Typography variant="h6" color="text.secondary">
          {t('entryList.noEntries')}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
          {t('entryList.noEntriesHint')}
        </Typography>
      </Paper>
    );
  }

  return (
    <Box>
      <Typography variant="h6" gutterBottom sx={{ mb: 2 }}>
        {t('entryList.entriesFound', { count: entries.length })}
      </Typography>

      <Grid container spacing={3}>
        {entries.map((entry) => (
          <Grid item xs={12} md={6} lg={4} key={entry.id}>
            <EntryCard
              entry={entry}
              onEdit={onEdit}
              onDelete={onDelete}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default EntryList;
